import * as RemoveIconThin from "@assets/images/svg/remove-icon-thin.svg";
import * as EyeIcon from "@assets/images/svg/eye.svg";
import * as EyeSlashIcon from "@assets/images/svg/eye-slash.svg";
import * as Background from "@assets/images/background.jpg";
import * as AvatarDefaultIcon from "@assets/images/svg/avatar-default.svg";
import * as NvidiaIcon from "@assets/images/svg/nvidia.svg";
import * as MoneyIcon from "@assets/images/svg/money.svg";
import * as RocketIcon from "@assets/images/svg/rocket.svg";
import * as RedshiftIcon from "@assets/images/svg/redshift.svg";
import * as BlenderIcon from "@assets/images/svg/blender.svg";
import * as OctaneIcon from "@assets/images/svg/octane.svg";
import * as IrayIcon from "@assets/images/svg/iray.svg";
import * as LogoPcRender from "@assets/images/logo.png";
import * as LogoPcRenderWhite from "@assets/images/logo-white.png";
import * as IdentityCardIcon from "@assets/images/svg/identity-card.svg";
import * as Log from "@assets/images/log.png";
import * as Clipboard from "@assets/images/clipboard.png";
import * as RemoteDesktop from "@assets/images/remote-desktop.png";
import * as Power from "@assets/images/power.png";
import * as Reset from "@assets/images/reset.png";
import * as Sync from "@assets/images/sync.png";
import * as MenuIcon from "@assets/images/menu.png";
import * as HomeIcon from "@assets/images/home.png";
import * as SandClockIcon from "@assets/images/sand-clock.png";
import * as ReConnect from "@assets/images/reconnect.png";
import * as Internet from "@assets/images/ip-address.png";
import * as IP from "@assets/images/ip.png";
import * as Tunnel from "@assets/images/tunnel.png";
import * as Window from "@assets/images/window.png";
import * as MacOS from "@assets/images/macos.png";
import * as Smartphone from "@assets/images/smartphone.png";
import * as UserGuide from "@assets/images/user-guide.png";
import * as Vps from "@assets/images/vps.png";
import * as Check from "@assets/images/check.png";
import * as Check2 from "@assets/images/check2.png";
import * as OrderVps from "@assets/images/OrderVps.png";
import * as Cloud from "@assets/images/cloud.png";
import * as Start from "@assets/images/start.png";
import * as Delete from "@assets/images/delete.png";
import * as Backup from "@assets/images/backup.png";
import * as Restore from "@assets/images/restore.png";
import * as Shutdown from "@assets/images/shutdown.png";
import * as OrderCloud from "@assets/images/order_cloud.png";
import * as More from "@assets/images/more.png";
import * as Settings from "@assets/images/settings.png";
import * as GameDownload from "@assets/images/game_dl.png";
import * as FileUserPassPlayPcrender from "@assets/images/file_u_p_play_pc.png";
import * as InviteUser from "@assets/images/invite_user.png";
import * as PC1 from "@assets/images/pc1.png";
import * as PC2 from "@assets/images/pc2.png";
import * as PC3 from "@assets/images/pc3.png";
import * as HomePoster from "@assets/images/home_poster.png";
import * as CloudGood1 from "@assets/images/cloud_good1.png";
import * as CloudGood2 from "@assets/images/cloud_good2.png";
import * as CloudGood3 from "@assets/images/cloud_good3.png";
import * as CloudGood4 from "@assets/images/cloud_good4.png";
import * as CloudPoster from "@assets/images/cloud_poster.png";
import * as OSS from "@assets/images/oss.jpg";
import * as Ekyc from "@assets/images/ekyc.png";
import * as Hardware from "@assets/images/hardware.png";

export const Images = {
  RemoveIconThin,
  EyeIcon,
  EyeSlashIcon,
  Background,
  AvatarDefaultIcon,
  NvidiaIcon,
  MoneyIcon,
  RocketIcon,
  RedshiftIcon,
  BlenderIcon,
  OctaneIcon,
  IrayIcon,
  LogoPcRender,
  LogoPcRenderWhite,
  IdentityCardIcon,
  Log,
  Clipboard,
  RemoteDesktop,
  Power,
  Sync,
  MenuIcon,
  HomeIcon,
  SandClockIcon,
  ReConnect,
  Internet,
  Reset,
  IP,
  Tunnel,
  Window,
  MacOS,
  UserGuide,
  Smartphone,
  Vps,
  Check,
  Check2,
  OrderVps,
  Cloud,
  Start,
  Delete,
  Backup,
  Restore,
  Shutdown,
  OrderCloud,
  More,
  Settings,
  GameDownload,
  FileUserPassPlayPcrender,
  InviteUser,
  PC1,
  PC2,
  PC3,
  HomePoster,
  CloudGood1,
  CloudGood2,
  CloudGood3,
  CloudGood4,
  CloudPoster,
  OSS,
  Ekyc,
  Hardware,
};
